import TagManager from "react-gtm-module";

const itemIsSaved = (itemType, itemId) => {
  TagManager.dataLayer({
    dataLayer: {
      event: "custom_event",
      event_category: "save",
      event_action: `${itemType}`,
      event_label: `${itemId}`
    }
  });
};

export { itemIsSaved };
